import React, { Component, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import IconButton from "@material-ui/core/IconButton";
import SettingsIcon from "@material-ui/icons/Settings";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import MoreVertOutlinedIcon from "@material-ui/icons/MoreVertOutlined";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import StudentPollHistory from "./StudentPollHistory";
import { getStudentVotes, archiveStudentCourse } from "../firebaseApi";
import StudentCategories from "./StudentCategories";
import StudentCourseDrop from "./StudentCourseDrop";
import StudentLocked from "./StudentLocked";
const styles = (theme) => ({});

function StudentMenuCourseItem(props) {
  let { course } = props;
  let { studentID } = props;

  const [courseAnchorEl, setAnchorEl] = useState(null);
  const [showPollHistory, setShowPoll] = useState(false);
  const [pollHistory, updatePollHistory] = useState(null);
  const [dropClass, updateDrop] = useState(false)
  const [showStudentCategories, setShowStudentCategories] = useState(false);
  const [showLocked, setShowLocked] = useState(false);
  let voteToTable = (sessionData, voteData,dateData) => {
    let voteTable = [];
    let voteIndex = 0;
    try {
      for (let i = 0; i < sessionData.length; i++) {
        let voteRow = {};
        let index = 0;
        let pollsVoted = 0;
        let votes = "";
        while (sessionData[i] > index) {
          
           
          if (voteData[voteIndex] == 'G') {
            votes = votes + "N/A, "
          }else if (voteData[voteIndex]) {
            pollsVoted++;
            votes = votes + voteData[voteIndex].replace("X", "") + ", ";
          } else {
            votes = votes + "N/A, ";
          }

          voteIndex++;
          index++;
        }
        let seshNum = i + 1;
        voteRow["sessions"] = "Session " + seshNum;
        voteRow["date"] = dateData[seshNum-1]
        voteRow["polls"] =
          "Voted in " + pollsVoted + "/" + sessionData[i] + " polls ";
        voteRow["votes"] = votes.substring(0, votes.length - 2);
        if (sessionData[i] != 0 && pollsVoted) {
          voteTable.push(voteRow);
        }
      }
      return voteTable;
    } catch (err) {
      //console.log(err);
    }
  };

  React.useEffect(() => {

    if (props.disable) return;

    if (
      props.match.params?.courseID == course?.courseID && 
      course?.chooseCategories && course.students[studentID]?.studentCategories &&
      !(
        Object.keys(course.students[studentID].studentCategories).length ===
        Object.keys(course.courseCategories).length
      )
    ) {
      setShowStudentCategories(true);
    }
    if (
      props.match.params?.courseID == course?.courseID &&
    (course.students[studentID].locked == "1")
      
    ) {
      setShowLocked(true);
    }
  }, [props.match.params.courseID, course?.courseActivitySessionID]);

  return (
    <>
      <ListItem button disabled={props.disable} selected={props.selected} onClick={props.selectCourse}>
        <ListItemText
          primary={course.courseName}
          secondary={course.courseTerm !== undefined ? course.courseTerm : ""}
        />
        {course.iClickerEn ? (
          <IconButton onClick={props.editCourse}>
            <SettingsIcon />
          </IconButton>
        ) : null}
        <ListItemSecondaryAction>
          <IconButton
            onClick={(event) => {
              setAnchorEl(event.currentTarget);
            }}
          >
            <MoreVertOutlinedIcon />
          </IconButton>
        </ListItemSecondaryAction>
      </ListItem>
      <Menu
        anchorEl={courseAnchorEl}
        open={Boolean(courseAnchorEl)}
        onClose={() => {
          setAnchorEl(null);
        }}
      >
        {course.chooseCategories ? (
          <MenuItem
            button={true}
            disabled={!course.chooseCategories}
            onClick={() => {
              
              try {
                setShowStudentCategories(true);
                setAnchorEl(null);
              } catch (err) {
                //console.error(err);
              }
            }}
          >
            Course Categories
          </MenuItem>
        ) : null}
        {course.studentPollHistory ? (
          <MenuItem
            button={true}
            disabled={!course.studentPollHistory}
            onClick={() => {
              console.log(props)
              try {
                getStudentVotes(course.courseID, studentID).then((data) => {
                  updatePollHistory(
                    voteToTable(data[0].sessions, data[1].studentVotes,data[0].dates)
                  );
                  setShowPoll(true);
                  setAnchorEl(null);
                });
              } catch (err) {
                //console.error(err);
              }
            }}
          >
            Show Poll History
          </MenuItem>
        ) : null}
        <MenuItem
            button={true}
            onClick={() => {
              let data = {
                email: props.studentID,
                courseID: course.courseID,
              };
              archiveStudentCourse(data);
              props.removeCourseFromMenu();
              setAnchorEl(null)
            }}
          >
            Archive Course
        </MenuItem>
        {false ? (<MenuItem
            button={true}
            onClick={() => {
             updateDrop(true);
             setAnchorEl(null)
            }}
            style={{color:"red"}}
          >
            Drop Class
          </MenuItem>) : null
          }
      </Menu>

      <StudentCategories
        open={showStudentCategories}
        openCtl={(open) => {
          setShowStudentCategories(open);
        }}
        course={course}
        studentID={studentID}
        refreshCourseListen={(courseID) => props.refreshCourseListen(courseID)}
      />
      <StudentLocked
        open={showLocked}
        openCtl={(open) => {
          //props.unselect(); // unselects them from this class, for now not do that. 
          setShowLocked(open);
        }}
        course={course}
        studentID={studentID}
        refreshCourseListen={(courseID) => props.refreshCourseListen(courseID)}
      />

      <StudentPollHistory
        open={showPollHistory}
        openCtl={(open) => {
          setShowPoll(open);
        }}
        course={course}
        studentID={studentID}
        courseID = {course.courseID}
        tableData={pollHistory}
      />
      
      <StudentCourseDrop
      open={dropClass}
      openCtl={(open) => {
        updateDrop(open);

      }}
      hidePoll = {(courseID)=> props.showPoll(courseID)}
      course={course}
      studentID={studentID}
      courseID = {course.courseID}
      
      />

    </>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    withStyles(styles, { withTheme: true })(withWidth()(StudentMenuCourseItem))
  )
);
